module.exports = __webpack_public_path__ + "static/media/galleryImg24.f5885907.jpg";